export const content = [
  {
    id: 0,
    resultIsImage: false,
    videoName: "vid1.mp4",
    resultSrc: "/results/resVid1.mp4",
    isGoal: true,
  },
  {
    id: 1,
    resultIsImage: false,
    videoName: "vid2.mp4",
    resultSrc: "/results/resVid2.mp4",
    isGoal: true,
  },
  {
    id: 2,
    resultIsImage: false,
    videoName: "vid3.mp4",
    resultSrc: "/results/resVid3.mp4",
    isGoal: true,
  },
  {
    id: 3,
    resultIsImage: false,
    videoName: "vid4.mp4",
    resultSrc: "/results/resVid4.mp4",
    isGoal: true,
  },
  {
    id: 4,
    resultIsImage: false,
    videoName: "vid5.mp4",
    resultSrc: "/results/resVid5.mp4",
    isGoal: false,
  },
  {
    id: 5,
    resultIsImage: false,
    videoName: "vid6.mp4",
    resultSrc: "/results/resVid6.mp4",
    isGoal: false,
  },
  {
    id: 6,
    resultIsImage: false,
    videoName: "vid7.mp4",
    resultSrc: "/results/resVid7.mp4",
    isGoal: true,
  },
  {
    id: 7,
    resultIsImage: false,
    videoName: "vid8.mp4",
    resultSrc: "/results/resVid8.mp4",
    isGoal: true,
  },
  {
    id: 8,
    resultIsImage: false,
    videoName: "vid9.mp4",
    resultSrc: "/results/resVid9.mp4",
    isGoal: false,
  },
];
